module.exports = __webpack_public_path__ + "img/forehead.6b8a53a0.svg";